<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed left-0 right-0 top-0 z-50 flex flex-col items-center gap-3 p-4"
    >
      <TransitionGroup name="toast">
        <ToastNotification
          v-for="toast in toastStore.toasts"
          :key="toast.id"
          :type="toast.type"
          :message="toast.message"
          :title="toast.title"
          :emoji="toast.emoji"
          :on-click="toast.click"
          @close="toastStore.removeToast(toast.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToastStore } from "@/stores/modules/toast/toast";
import ToastNotification from "./ToastNotification.vue";

const toastStore = useToastStore();
</script>

<style scoped>
.toast-move,
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-active {
  position: absolute;
}
</style>
